/**
 * Stable media-set key for gallery effects — avoids slide reset when array reference
 * changes but slide URLs are unchanged (scroll-driven parent re-renders).
 *
 * @param {Array<{disBaseLink?: string, link?: string, videoUrl?: string}>|null|undefined} images
 * @returns {string}
 */
export function buildGalleryMediaKey(images) {
  if (!Array.isArray(images) || images.length === 0) {
    return '';
  }

  return images
    .map((media) => media?.disBaseLink || media?.link || media?.videoUrl || '')
    .join('|');
}

/**
 * Swiper `update()` with `loop: true` can jump back to slide 0. Preserve the active slide.
 *
 * @param {import('swiper').Swiper|null|undefined} swiper
 */
export function updateSwiperPreservingSlide(swiper) {
  if (!swiper || swiper.destroyed) {
    return;
  }

  const idx =
    typeof swiper.realIndex === 'number'
      ? swiper.realIndex
      : typeof swiper.activeIndex === 'number'
        ? swiper.activeIndex
        : 0;

  swiper.update();

  if (idx === 0) {
    return;
  }

  if (swiper.params?.loop) {
    swiper.slideToLoop(idx, 0);
  } else if ((swiper.realIndex ?? swiper.activeIndex) !== idx) {
    swiper.slideTo(idx, 0);
  }
}
